/**
 * @module common/utils/generate-controller-states
 */

/**
 * @typedef {Object} ActionState
 * @property {Object} status - Статус запроса
 * @property {Boolean} status.isPending - Запрос в процессе
 * @property {Boolean} status.isFailed - Запрос не удался
 * @property {Boolean} status.isSucceeded - Запрос удался
 * @property {*} data - Данные запроса
 * @property {*} error - Ошибка запроса
 */

/**
 * @function
 * @description Генерирует состояния запросов в контроллере API
 * @param {string[]} methods - Методы в контроллере
 * @returns {ActionState}
 */
function generateControllerStates(methods) {
  const states = {};
  methods.forEach((method) => {
    states[method] = {
      status: {
        isPending: false,
        isFailed: false,
        isSucceeded: false,
      },
      data: null,
      error: null,
    };
  });
  return states;
}

export default generateControllerStates;
